import _ from 'lodash';
import { connect } from 'react-redux';
import { search, searchLogs, advancedSearch } from '../../modules/accounting/stationInvoice';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';

const mapStateToProps = (state, ownProps) => {

	/** @namespace state.lists.stationInvoiceIds **/
	/** @namespace state.maps.stationInvoice **/
	/** @namespace state.maps.user **/
	let pendingStationInvoices = undefined;
	let invalidStationInvoices = undefined;
	let issuedStationInvoices  = undefined;
	if (state.stationInvoices.byStatus) {
		const { pending, issued, invalid, credited } = state.stationInvoices.byStatus;
		if (pending) {
			pendingStationInvoices = _.map(pending, id => state.maps.stationInvoice[id]);
		}
		if (invalid || credited) {
			//- Credited (fully credited via credit & rebill) rides in the invalid tab so
			//- the original invoice doesn't vanish from the lists entirely
			invalidStationInvoices = _.map(
				_.uniq((invalid || []).concat(credited || [])),
				id => state.maps.stationInvoice[id]
			);
		}
		if (issued) {
			issuedStationInvoices = _.map(issued, id => state.maps.stationInvoice[id]);
		}
	}

	let stationInvoice;
	let stationInvoiceId;

	if (ownProps.stationInvoice) {
		stationInvoice = ownProps.stationInvoice;
		stationInvoiceId = stationInvoice.stationInvoiceId;
	} else {
		stationInvoiceId = (ownProps.stationInvoiceId)
			? ownProps.stationInvoiceId
			: _.get(ownProps, ['match', 'params', 'stationInvoiceId']);
		stationInvoice = _.get(state.maps, ['stationInvoice', stationInvoiceId]);
	}


	let stationInvoiceLogs = [];
	/** @namespace state.lists.stationInvoiceLogIds **/
	/** @namespace state.lists.stationInvoiceLog **/

	if (
		state.lists.stationInvoiceLogIds &&
		state.lists.stationInvoiceLogIds[stationInvoiceId]
	) {
		stationInvoiceLogs = _.map(state.lists.stationInvoiceLogIds[stationInvoiceId],
			id => state.maps.stationInvoiceLog[id]
		);
	}

	const canMakeUpdates = !!(_.get(state.auth.authUser, ['permissions', 'canMakeUpdates'], false));
	return {
		stationInvoice,
		stationInvoiceLogs,
		pendingStationInvoices,
		invalidStationInvoices,
		issuedStationInvoices,
		userMap : state.maps.user,
		stationMap : state.maps.station,
		supplierMap : state.maps.supplier,
		terminalMap : state.maps.terminal,
		carrierMap : state.maps.carrier,
		resourceMap : state.maps.resource,
		invoiceDocumentMap : state.maps.invoiceDocument,
		stationDeliveryMap : state.maps.stationDelivery,
		canMakeUpdates,
	};
};
const mapDispatchToProps = dispatch => bindActionCreators({
	searchStationInvoices : search,
	advancedSearchStationInvoices : advancedSearch,
	searchStationInvoiceLogs : searchLogs,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
